import { createContext } from 'react';

export interface AppBarContextInterface {
  showAppBar: boolean;
  showHistoryButtons: boolean;
  showPeriodSelector: boolean;
  selectedPeriod: any;
  valueInputNavigationTarget: string | undefined;
  setAppBar: (value: boolean) => void;
  setHistoryButtons: (value: boolean) => void;
  setPeriodSelector: (value: boolean) => void;
  setPeriod: (value: any) => void;
  getPeriodName: () => string;
  setValueInputNavigationTarget: (value: string) => void;
}

const initialAppBarContext = {
  showAppBar: true,
  showHistoryButtons: true,
  showPeriodSelector: true,
  selectedPeriod: undefined,
  valueInputNavigationTarget: undefined,
  setAppBar: (): void => {},
  setHistoryButtons: (): void => {},
  setPeriod: (): void => {},
  setPeriodSelector: (): void => {},
  getPeriodName: (): string => '',
  setValueInputNavigationTarget: (): string => ''
};

const AppBarContext = createContext<AppBarContextInterface>(initialAppBarContext);

export default AppBarContext;
